const STORAGE_KEY = "chattu_browser_notif_enabled";

export const isBrowserNotifEnabled = () => {
  return localStorage.getItem(STORAGE_KEY) === "true";
};

export const setBrowserNotifEnabled = (val) => {
  localStorage.setItem(STORAGE_KEY, val ? "true" : "false");
};

export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) return false;
  if (Notification.permission === "granted") return true;
  if (Notification.permission === "denied") return false;
  const result = await Notification.requestPermission();
  return result === "granted";
};

export const sendBrowserNotification = (title, options = {}) => {
  if (!isBrowserNotifEnabled()) return;
  if (!("Notification" in window)) return;
  if (Notification.permission !== "granted") return;

  const notif = new Notification(title, {
    icon: "/logo.png",
    badge: "/logo.png",
    ...options,
  });

  // Auto-close after 5 seconds
  setTimeout(() => notif.close(), 5000);

  // Focus tab when clicked
  notif.onclick = () => {
    window.focus();
    notif.close();
  };

  return notif;
};
